<template>
    <div class="row bg">
        <div class="flex xs12 align-self--center align-content--center set-content" :style="{ 'height': bgHeight }">
            <div class="d-flex justify--center text-center ">
                <div class="container set-top">
                    <template>
                        <div>
                            <va-button class="py-1 my-32 mx-auto p--next--bottom w-100" color="primary"
                                @click="nextBrand" small><span>เทียบเฉดสีจากแป้งที่ใช้</span></va-button>
                        </div>
                        <div>
                            <va-button class="py-1 my-2 mx-auto p--next--bottom w-100" color="primary" @click="nextTone"
                                small><span>เช็คเฉดสีจากแบบทดสอบ</span></va-button>
                        </div>
                        <div>
                            <va-button class="py-1 my-2 mx-auto p--next--bottom w-100" color="primary"
                                @click="nextFilter" small><span>ทดลองเฉดสีด้วยฟิวเตอร์</span></va-button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    ColorThemeMixin
} from '../../../services/vuestic-ui'
export default {
    mixins: [ColorThemeMixin],
    data() {
        return {
            bgHeight: '',
            mobile: '',
            session: ''
        }
    },
    async created() {
        window.scrollTo(0, 0);
        localStorage.clear();

        this.session = Number(new Date());
        localStorage.setItem(`session`, this.session);

        // ถ้าอยากให้ reponsive ความสูงพอดี สำหรับหน้าที่มีการกำหนด height
        this.resize();
        window.addEventListener("resize", this.resize);

        // get mobile
        this.mobile = this.$route.params.mobile;
        if (this.mobile != undefined && this.mobile !== '') {
            localStorage.setItem(`mobile`, this.mobile);
            this.$router.replace({
                path: `/`,
            });
        }
    },
    methods: {
        // btn next filter
        nextFilter() {
            window.location = 'https://vt.tiktok.com/ZS283rLvG/';
        },
        // btn next "เลือกเเป้ง"
        nextBrand() {
            this.$router.push({ path: '/powder', name: 'powder' }).catch(() => true);
        },
        // btn next "เลือก undertone"
        nextTone() {
            this.$router.push({ path: '/undertone', name: 'undertone' }).catch(() => true);
        },
        // resize screen
        async resize() {
            this.bgHeight = await this.$store.dispatch("resize");
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/speciefied.scss";

.p--content {
    font-size: 18px;
}

.container {
    padding-left: 55px;
    padding-right: 55px;
}

.bg {
    background-image: url('~@/assets/image/bg-home.jpg');
}

@media screen and (min-width: 320px) and (max-width: 767px) {
    .set-content {
        top: 0;
        position: absolute;
        width: 100%;
    }
}

@media only screen and (min-width : 768px) {
    .set-content {
        height: auto !important;
    }
}
</style>
